export const passwordRecovery = {
  title: 'Cadastre a nova senha',
  subtitle: 'Informe sua nova senha',
  submit: 'Salvar',
  inputs: {
    password: {
      label: 'Nova Senha',
    },
    passwordConfirm: {
      label: 'Confirmar nova senha',
    },
  },
  goToHome: 'Voltar',
  messages: {
    success: 'Nova senha cadastrada com sucesso.',
  },
  errors: {
    password: {
      invalid: 'A nova senha não atende aos critérios necessários',
      minLength: 'A senha deve conter no mínimo 6 caracteres',
      lowerCase: 'A senha deve conter uma letra minúscula',
      upperCase: 'A senha deve conter uma letra maiúscula',
      number: 'A senha deve conter número',
      specialChars: 'A senha deve conter caractere especial',
      required: 'Este campo é obrigatório',
    },
    confirmPassword: {
      mismatch: 'A confirmação da senha não está idêntica à nova senha',
      required: 'Este campo é obrigatório',
    },
  },
};
